"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const withSubmit = Component => props => _react.default.createElement(_.FormConsumer, null, ({
  fieldsData,
  setValue
}) => _react.default.createElement(Component, _extends({}, props, {
  submit: (e, callback, reset) => {
    e.preventDefault();

    if ((0, _.formIsInvalid)(fieldsData)) {
      // Trigger valdiation check of all fields.
      Object.entries(fieldsData).forEach(([key, data]) => {
        const value = data.value,
              required = data.required,
              type = data.type;
        setValue(key, value, required, {
          type
        });
      });

      if (!props.suppressErrorMessage) {
        props.theme.errorNotificationFunc(props.theme.textLabels.formInvalid);
      }
    } else {
      callback && callback((0, _.getValues)(fieldsData));
      reset && setValue();
    }
  }
})));

var _default = withSubmit;
exports.default = _default;